import PropTypes from 'prop-types';

import DatePresenter from '../presenters/DatePresenter';
import PropTypesPresenter from '../utils/PropTypesPresenter';

const CREATE_FAST_CASH = 'create_fast_cash';
const ADD_INSTITUTION = 'add_institution';
const DELETE_INSTITUTION = 'delete_institution';
const RELOGIN_INTO_PLAID = 'relogin_into_plaid';
const ITEM_ERROR = 'item_error';

export default new PropTypesPresenter(
  {
    id: PropTypes.number,
    eventType: PropTypes.string,
    meta: PropTypes.shape({
      institutionId: PropTypes.string,
      institutionName: PropTypes.string,
    }),
    createdAt: PropTypes.string,
  },
  {
    eventTypeReadable(log) {
      switch (this.eventType(log)) {
        case CREATE_FAST_CASH:
          return 'Create fast cash';
        case ADD_INSTITUTION:
          return 'Add institution';
        case DELETE_INSTITUTION:
          return 'Delete institution';
        case RELOGIN_INTO_PLAID:
          return 'Relogin into plaid';
        case ITEM_ERROR:
          return 'Item error';
      }
    },
    printMeta(log) {
      return JSON.stringify(this.meta(log));
    },
    detailedFormattedDate(log) {
      return DatePresenter.detailedFormattedDate(this.createdAt(log));
    },
  }
);
